import React, { Component } from "react";
import { Link } from "react-router-dom";

import { getPagePath } from "./../../helpers/system";

export default class SeekCapLogo extends Component {
    onClick(e) {
        const { onClick = false } = this.props;

        if (onClick) {
            return onClick(e);
        }
        return true;
    }

    render() {
        let { darkmode = false, className = [], link = getPagePath("HomePage"), type = false } = this.props;

        if (className && typeof className === "string") {
            className = [className];
        }

        if (darkmode) {
            className.push("white");
        }

        if (type) {
            className.push(type);
        }

        return (
            <Link
                to={link}
                id="main-logo"
                title="SeekCap"
                className={className.join(" ")}
                onClick={(e) => this.onClick(e)}
            >
                SeekCap
            </Link>
        );
    }
}
